<template>
  <div class="menu-page">
    <div class="menu-header">
      <img v-if="user.mthumb" :src="user.mthumb" class="header-avatar"/>
      <img v-else class="header-avatar" src="../../../assets/img/defailt-avatar.png"/>
      <div class="header-name">{{ user.mnickname }}</div>
    </div>
    <div class="menus">
      <div v-for="(item,index) in menus" :key="index" class="flex flex-direction">
        <router-link :class="{ active: navIndex[0]  == item.value}"
                     :to="`${item.page}`"
                     class="mune-item">
          <i :class="[{active: navIndex[0]  == item.value},item.icon]" class="iconfont"></i>
          <div :class="{ active: navIndex[0]  == item.value}" class="title">{{ item.label }}</div>
        </router-link>
      </div>

    </div>
  </div>
</template>

<script>
import {menus} from "@/utils/const";

export default {
  name: "MenuModular",
  data() {
    return {
      menus: menus,
    };
  },
  props: {
    navIndex: {},
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  created() {

  },
  methods: {

  },
  watch: {

  },
};
</script>

<style lang="scss" scoped>
.menu-page {
  display: flex;
  flex-direction: column;
  width: 170px;
  flex-shrink: 0;

  .menu-header {
    width: 100%;
    min-height: 157px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #0a2240;
    border-radius: 10px;
    padding: 12px 26px;

    .header-avatar {
      width: 85px;
      height: 85px;
      border-radius: 85px;
    }

    .header-name {
      text-align: center;
      font-size: 14px;
      line-height: 18px;
      color: #ffffff;
      margin-top: 12px;
    }
  }

  .menus {
    width: 100%;
    flex: 1;
    background-color: #0a2240;
    box-shadow: 0 6px 16px 1px rgba(10, 34, 64, 0.47);
    border-radius: 10px;
    margin-top: 10px;

    .mune-item {
      height: 100px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: none;
      position: relative;

      &:after {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 1px;
        background: #ffffff33;
        transform: translateY(-50%);
        content: '';
      }

      &.active {
        background: #233953;
        border-radius: 10px;

        &:before {
          position: absolute;
          right: -8px;
          border-top: 8px solid transparent;
          border-left: 8px solid #233953;
          border-bottom: 8px solid transparent;
          top: 50%;
          transform: translateY(-50%);
          content: '';
        }
      }

      .title {
        font-size: 18px;
        color: #ffffff;
        margin-top: 10px;

        &.active {
          color: #ff9600;

        }
      }

      i {
        font-size: 30px;
        color: #ffffff;

        &.active {
          color: #ff9600;

        }
      }
    }
  }

}
</style>
